export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-primary-600">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
              移动观影
            </h2>
            <p className="text-base text-white/75 leading-relaxed mb-6 max-w-lg lg:max-w-none">
              97影院移动端适配完美，手机、平板随时随地畅享高清电影。无需下载，浏览器打开即可观看。
              支持投屏功能，大屏观影更过瘾。收藏片单云端同步，换设备不丢失。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-white text-sm">
                <i className="ri-smartphone-line"></i>
                手机适配
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-white text-sm">
                <i className="ri-tablet-line"></i>
                平板体验
              </span>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-white text-sm">
                <i className="ri-cast-line"></i>
                投屏支持
              </span>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-56 h-96 rounded-3xl overflow-hidden border-4 border-white/20 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20showing%20movie%20streaming%20app%20interface%20with%20film%20posters%2C%20clean%20dark%20UI%20design%20with%20warm%20accent%20colors%2C%20cinema%20app%20mockup%2C%20minimalist%20phone%20frame%2C%20soft%20studio%20lighting%2C%20professional%20product%20photography&width=600&height=1200&seq=app-mockup-97&orientation=portrait"
                alt="97影院移动观影"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}